export default {
      id: "floor-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#floor",
      toString: function () {
        return this.url;
      }
    }